// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * User Create Modal Styles
 * Clean, responsive styles with proper scrolling
 */

/* Modal Overlay - Now using global styles from design-system.css */

/* Modal Container - Now using global styles from design-system.css */

/* Modal Header - Now using global styles from design-system.css */

/* Close button - Now using global .modal-close styles from design-system.css */

/* Modal Body - Now using global styles from design-system.css */

/* Form Sections - Now using global styles from design-system.css */

/* Form Rows and Groups - Now using global styles from design-system.css */

/* Checkbox Group - Now using global styles from design-system.css */

/* Error Messages */
.error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 0.9rem;
}

.field-error {
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 4px;
}

/* Modal Footer */
.modal-footer {
  padding: 20px 24px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
}

/* Buttons - Now using global styles from design-system.css */

/* Responsive Design */
@media (min-width: 768px) {
  .form-row {
    grid-template-columns: 1fr 1fr;
  }

  .form-row:first-child {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .modal-overlay {
    padding: 10px;
  }

  .modal-container {
    max-height: 95vh;
  }

  .modal-header {
    padding: 16px 20px;
  }

  .modal-header h2 {
    font-size: 1.3rem;
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    padding: 16px 20px;
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .modal-header {
    padding: 12px 16px;
  }

  .modal-body {
    padding: 16px;
  }

  .modal-footer {
    padding: 12px 16px;
  }

  .form-section {
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/users/UserCreateModal.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,mEAAmE;;AAEnE,qEAAqE;;AAErE,kEAAkE;;AAElE,+EAA+E;;AAE/E,gEAAgE;;AAEhE,mEAAmE;;AAEnE,0EAA0E;;AAE1E,oEAAoE;;AAEpE,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA,6DAA6D;;AAE7D,sBAAsB;AACtB;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/**\n * User Create Modal Styles\n * Clean, responsive styles with proper scrolling\n */\n\n/* Modal Overlay - Now using global styles from design-system.css */\n\n/* Modal Container - Now using global styles from design-system.css */\n\n/* Modal Header - Now using global styles from design-system.css */\n\n/* Close button - Now using global .modal-close styles from design-system.css */\n\n/* Modal Body - Now using global styles from design-system.css */\n\n/* Form Sections - Now using global styles from design-system.css */\n\n/* Form Rows and Groups - Now using global styles from design-system.css */\n\n/* Checkbox Group - Now using global styles from design-system.css */\n\n/* Error Messages */\n.error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  font-size: 0.9rem;\n}\n\n.field-error {\n  color: #dc3545;\n  font-size: 0.8rem;\n  margin-top: 4px;\n}\n\n/* Modal Footer */\n.modal-footer {\n  padding: 20px 24px;\n  background: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n/* Buttons - Now using global styles from design-system.css */\n\n/* Responsive Design */\n@media (min-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .form-row:first-child {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 767px) {\n  .modal-overlay {\n    padding: 10px;\n  }\n\n  .modal-container {\n    max-height: 95vh;\n  }\n\n  .modal-header {\n    padding: 16px 20px;\n  }\n\n  .modal-header h2 {\n    font-size: 1.3rem;\n  }\n\n  .modal-body {\n    padding: 20px;\n  }\n\n  .modal-footer {\n    padding: 16px 20px;\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-header {\n    padding: 12px 16px;\n  }\n\n  .modal-body {\n    padding: 16px;\n  }\n\n  .modal-footer {\n    padding: 12px 16px;\n  }\n\n  .form-section {\n    margin-bottom: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
